import RichText from 'Custom/RichText';
import Link from 'node_modules/next/link';
import styles from 'styles/pages/questions.module.scss';

const FAQ_USERS_1_LIST = [
  'Dolor que no cesa en la parte inferior de la pierna',
  'Dolor de pecho intenso u opresión en el pecho',
  'Dificultad repentina para respirar, fuerte dolor de pecho o tos con sangre',
  'Síntomas de una reacción alérgica grave, como hinchazón de la cara, la lengua o la garganta; dificultad para tragar o para respirar',
  'Dolor de cabeza intenso y repentino distinto de los dolores de cabeza habituales',
  'Debilidad o adormecimiento en el brazo o la pierna, o dificultad para hablar',
  'Ceguera repentina parcial o total',
  'Color amarillento de la piel o la parte blanca de los ojos, especialmente acompañado de fiebre, cansancio, pérdida del apetito, orina de color oscuro o heces de color claro',
  'Dolor intenso, hinchazón o sensibilidad en la parte inferior del abdomen',
  'Un bulto en el seno',
  'Problemas para dormir, falta de energía, cansancio o mucha tristeza',
  'Sangrado menstrual abundante',
  'Sensación de que el implante puede haberse roto o doblado cuando está en su brazo',
];

export const FAQ_USERS_2_LIST = [
  'Aprepitant',
  'Barbitúricos',
  'Bosentán',
  'Carbamazepina',
  'Felbamato',
  'Griseofulvina',
  'Oxcarbazepina',
  'Fenitoína',
  'Rifampicina',
  'Hierba de San Juan',
  'Topiramato',
  'Medicamentos para el VIH',
  'Medicamentos para tratar el virus de la hepatitis C',
];

const FAQ_USERS_3_LIST_1 = [
  'Está embarazada o cree que podría estarlo',
  'Tiene o tuvo coágulos de sangre, como coágulos de sangre en las piernas (trombosis venosa profunda), los pulmones (embolia pulmonar), los ojos (ceguera parcial o total), el corazón (ataque cardíaco) o el cerebro (accidente cerebrovascular)',
  'Tiene una enfermedad hepática o un tumor hepático',
  'Tiene sangrado vaginal sin motivo aparente',
  'Tiene o ha tenido cáncer de mama u otro tipo de cáncer sensible a la progestina (una hormona femenina)',
  'Es alérgica a algún componente de NEXPLANON',
];

const FAQ_USERS_3_LIST_2 = [
  'Diabetes',
  'Colesterol o triglicéridos elevados',
  'Dolores de cabeza',
  'Problemas de la vesícula biliar o de los riñones',
  'Antecedentes de estado de ánimo depresivo',
  'Presión arterial alta',
  'Alergia a los medicamentos que se utilizan para anestesiar (anestésicos) o a los medicamentos que se utilizan para limpiar la piel (antisépticos). Estos medicamentos se utilizarán al colocar o extraer el implante de su brazo',
];

const FAQ_EXPLORING_QUESTION_1 = {
  title: '¿NEXPLANON es un anticonceptivo de acción prolongada?',
  linkLabel: 'implante anticonceptivo ',
  link: '/what-is-nexplanon/',
  initialContent: 'Yes, NEXPLANON es un ',
  complementaryContent: (
    <>
      (aproximadamente del tamaño de un fósforo), delgado y flexible que ofrece
      5 años<sup>†</sup> de prevención continua del embarazo. Un profesional de
      la salud capacitado lo coloca en un lugar discreto debajo la piel en el
      lado interno de su brazo no dominante.
    </>
  ),
  caption: (
    <>
      <sup>†</sup>NEXPLANON se debe extraer hacia el final del quinto año.
    </>
  ),
};

const FAQ_EXPLORING_QUESTION_1_FAQ = {
  title: FAQ_EXPLORING_QUESTION_1.title,
  content: (
    <RichText className={styles.initialContentColor}>
      <p data-qa-tag="faq-question-1-paragraph">
        {FAQ_EXPLORING_QUESTION_1.initialContent}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_1.linkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-design-element_no="01"
          data-qa-tag="faq-question-1-link"
          href={FAQ_EXPLORING_QUESTION_1.link}
        >
          {FAQ_EXPLORING_QUESTION_1.linkLabel}
        </Link>
        {FAQ_EXPLORING_QUESTION_1.complementaryContent}
      </p>
      <p className="caption mt-2" data-qa-tag="faq-question-1-caption">
        {FAQ_EXPLORING_QUESTION_1.caption}
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_2 = {
  title: '¿NEXPLANON es un dispositivo intrauterino?',
  linkLabel: 'anticonceptiva de acción prolongada',
  link: '/birth-control-options/',
  initialContent:
    'No, no es un dispositivo intrauterino (DIU). Es un implante que se coloca en su brazo. Al igual que un DIU, es una opción ',
  complementaryContent: (
    <>
      . NEXPLANON dura 5 años.<sup>†</sup>
    </>
  ),
  caption: (
    <>
      <sup>†</sup>NEXPLANON se debe extraer hacia el final del quinto año.
    </>
  ),
};

const FAQ_EXPLORING_QUESTION_2_FAQ = {
  title: FAQ_EXPLORING_QUESTION_2.title,
  content: (
    <RichText>
      <p data-qa-tag="faq-question-2-paragraph">
        {FAQ_EXPLORING_QUESTION_2.initialContent}{' '}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_2.linkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-qa-tag="faq-question-2-link"
          data-design-element_no="02"
          href={FAQ_EXPLORING_QUESTION_2.link}
        >
          {FAQ_EXPLORING_QUESTION_2.linkLabel}
        </Link>
        {FAQ_EXPLORING_QUESTION_2.complementaryContent}
      </p>
      <p className="caption mt-2" data-qa-tag="faq-question-2-caption">
        {FAQ_EXPLORING_QUESTION_2.caption}
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_3 = {
  title: '¿Qué tamaño tiene NEXPLANON?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-3-paragraph">
        NEXPLANON mide 4 centimetros (1,6 pulgadas) de largo, tiene
        aproximadamente el tamaño de un fósforo.
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_4 = {
  title: '¿Cómo funciona NEXPLANON?',
  linkLabel: 'NEXPLANON previene el embarazo',
  link: '/how-does-nexplanon-work/',
  firstParagraph: (
    <>
      NEXPLANON es un implante anticonceptivo liberador de hormonas para uso en
      mujeres que previene el embarazo durante un período de hasta 5 años.
      <sup>†</sup>
    </>
  ),
  thirdParagraph: 'NEXPLANON también modifica el revestimiento de su útero.',
  complementaryContent:
    ' de varias maneras. La más importante consiste en interrumpir la liberación de un óvulo desde su ovario. NEXPLANON también hace más espeso el moco cervical, y este cambio puede evitar que los espermatozoides lleguen al óvulo.',
  caption: (
    <>
      <sup>†</sup>NEXPLANON se debe extraer hacia el final del quinto año.
    </>
  ),
};

const FAQ_EXPLORING_QUESTION_4_FAQ = {
  title: FAQ_EXPLORING_QUESTION_4.title,
  content: (
    <RichText>
      <p data-qa-tag="faq-question-4-paragraph">
        {FAQ_EXPLORING_QUESTION_4.firstParagraph}
      </p>
      <p>
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_4.linkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-qa-tag="faq-question-4-link"
          data-design-element_no="04"
          href={FAQ_EXPLORING_QUESTION_4.link}
        >
          {FAQ_EXPLORING_QUESTION_4.linkLabel}
        </Link>
        {FAQ_EXPLORING_QUESTION_4.complementaryContent}
      </p>
      <p data-qa-tag="faq-exploring-question-4-third-paragraph">
        {FAQ_EXPLORING_QUESTION_4.thirdParagraph}
      </p>
      <p className="caption mt-2" data-qa-tag="faq-question-4-caption">
        {FAQ_EXPLORING_QUESTION_4.caption}
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_5 = {
  title: '¿NEXPLANON contiene estrógeno?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-5-paragraph">
        No. NEXPLANON no contiene estrógeno.
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_6 = {
  title: '¿NEXPLANON funciona tan bien como la píldora?',
  content: `NEXPLANON tiene una eficacia mayor del 99 % (menos de 1 embarazo por cada 100 mujeres que usaron NEXPLANON durante 1 año) para prevenir el embarazo. NEXPLANON es uno de los `,
  linkLabel: 'métodos anticonceptivos más eficaces disponibles',
  link: '/effectiveness/',
};

const FAQ_EXPLORING_QUESTION_6_FAQ = {
  title: FAQ_EXPLORING_QUESTION_6.title,
  content: (
    <RichText>
      <p data-qa-tag="faq-question-6-paragraph">
        {`${FAQ_EXPLORING_QUESTION_6.content} `}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_6.linkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="acerca de NEXPLANON"
          data-design-module_no="02"
          data-design-element_no="06"
          data-qa-tag="faq-question-6-link"
          href={FAQ_EXPLORING_QUESTION_6.link}
        >
          {FAQ_EXPLORING_QUESTION_6.linkLabel}
        </Link>
        .
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_7 = {
  title: '¿Qué pasa si quiero usar NEXPLANON por más de 5 años?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-7-paragraph">
        El implante NEXPLANON{' '}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label="implant must be removed"
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-qa-tag="faq-question-7-link"
          data-design-element_no="07"
          href="/removal/"
        >
          se debe extraer
        </Link>{' '}
        hacia el final del quinto año. Un profesional de la salud capacitado
        puede insertarle un nuevo implante debajo de la piel después de extraer
        el anterior si usted decide continuar utilizando NEXPLANON como método
        anticonceptivo.
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_8 = {
  title:
    '¿Qué sucede si cambio de opinión y quiero dejar de usar NEXPLANON antes de los 5 años?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-8-paragraph">
        Un profesional de la salud capacitado puede extraer el implante en
        cualquier momento dentro del período de 5 años. Usted puede quedar
        embarazada a partir de la primera semana después de la extracción del
        implante. Si no desea quedar embarazada después la extracción del
        implante NEXPLANON, debe comenzar a utilizar otro método anticonceptivo
        (como condones) de inmediato.
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_9 = {
  title: '¿NEXPLANON afecta mis períodos?',
  firstLinkLabel: ' patrón normal de sangrado menstrual',
  firstLink:
    'https://organonpro.com/en-us/product/nexplanon/about-nexplanon/safety-including-bleeding-changes/',
  secondLinkLabel: ' manchados entre los períodos',
  secondLink: '/period-changes/',
  initialContent:
    'El efecto secundario más frecuente de NEXPLANON es un cambio en su',
  complementaryContent:
    '. En estudios realizados, 1 de cada 10 mujeres dejó de usar el implante debido a un cambio desfavorable en su patrón de sangrado. Puede que sus períodos sean más prolongados o más breves, o puede que no tenga ningún sangrado. El tiempo entre períodos puede variar, y también puede tener',
};

const FAQ_EXPLORING_QUESTION_9_FAQ = {
  title: FAQ_EXPLORING_QUESTION_9.title,
  content: (
    <RichText>
      <p data-qa-tag="faq-question-9-paragraph">
        {FAQ_EXPLORING_QUESTION_9.initialContent}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_9.firstLinkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-qa-tag="faq-question-9-link"
          data-design-element_no="09"
          href={FAQ_EXPLORING_QUESTION_9.firstLink}
          target="_blank"
        >
          {FAQ_EXPLORING_QUESTION_9.firstLinkLabel}
        </Link>
        {FAQ_EXPLORING_QUESTION_9.complementaryContent}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_EXPLORING_QUESTION_9.secondLinkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-design-element_no="09"
          data-qa-tag="faq-question-9-link-2"
          href={FAQ_EXPLORING_QUESTION_9.secondLink}
        >
          {FAQ_EXPLORING_QUESTION_9.secondLinkLabel}
        </Link>
        .
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_10 = {
  title: '¿Cuándo deberían insertarme NEXPLANON en el brazo?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-10-paragraph">
        Su profesional de la salud la ayudará a determinar cuándo se debe{' '}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label="NEXPLANON inserted"
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-design-element_no="10"
          data-qa-tag="faq-question-10-link"
          href="/insertion/"
        >
          insertar NEXPLANON
        </Link>
        . El momento dependerá de si actualmente usa anticonceptivos y de qué
        método esté usando. No debe usar NEXPLANON si está embarazada o cree que
        puede estarlo.
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_11 = {
  title: '¿Cómo se extrae NEXPLANON?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-11-paragraph">
        Un profesional de la salud capacitado le puede extraer NEXPLANON en
        cualquier momento durante el período de 5 años en una intervención
        quirúrgica menor, pero debe extraerse antes de que finalice el quinto
        año. Para obtener más información sobre cómo se extrae NEXPLANON,{' '}
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label="click here"
          data-design-nori_id="Accordion"
          data-design-module_name="exploring NEXPLANON"
          data-design-module_no="02"
          data-design-element_no="11"
          data-qa-tag="faq-question-11-link"
          href="/removal/"
        >
          haga clic aquí
        </Link>
        .
      </p>
    </RichText>
  ),
};

const FAQ_EXPLORING_QUESTION_12 = {
  title:
    '¿Puedo utilizar NEXPLANON si tengo un índice de masa corporal superior a 29?',
  content: (
    <RichText>
      <p data-qa-tag="faq-question-12-paragraph">
        NEXPLANON es un anticonceptivo para mujeres con distintos pesos
        corporales. En ensayos clínicos de hasta 3 años, se excluyó a mujeres
        que superaban el 130 % de su peso corporal ideal. En un ensayo clínico,
        en el período correspondiente a los años 4 y 5, el índice de masa
        corporal de las participantes osciló entre 17.2 y 64.3 kg/m<sup>2</sup>.
      </p>
    </RichText>
  ),
};

export const FAQ_EXPLORING_QUESTIONS = [
  FAQ_EXPLORING_QUESTION_1_FAQ,
  FAQ_EXPLORING_QUESTION_2_FAQ,
  FAQ_EXPLORING_QUESTION_3,
  FAQ_EXPLORING_QUESTION_4_FAQ,
  FAQ_EXPLORING_QUESTION_5,
  FAQ_EXPLORING_QUESTION_6_FAQ,
  FAQ_EXPLORING_QUESTION_7,
  FAQ_EXPLORING_QUESTION_8,
  FAQ_EXPLORING_QUESTION_9_FAQ,
  FAQ_EXPLORING_QUESTION_10,
  FAQ_EXPLORING_QUESTION_11,
  FAQ_EXPLORING_QUESTION_12,
];

const FAQ_USERS_QUESTION_1 = {
  title: '¿Cuándo debo llamar a mi profesional de la salud?',
  firstLinkLabel: 'Llame de inmediato a su profesional de la salud',
  firstLink: '/calling-your-doctor/',
  complementaryContent: ' si tiene:',
};

const FAQ_NEXPLANON_USERS_QUESTION_1 = {
  title: FAQ_USERS_QUESTION_1.title,
  content: (
    <RichText>
      <p data-qa-tag="faq-nexplanon-question-1-paragraph">
        <Link
          data-design-category="content_link_vd"
          data-design-type="clickAction"
          data-design-action="Link"
          data-design-label={FAQ_USERS_QUESTION_1.firstLinkLabel}
          data-design-nori_id="Accordion"
          data-design-module_name="using NEXPLANON"
          data-design-module_no="03"
          data-design-element_no="01"
          data-qa-tag="faq-nexplanon-question-1-link"
          href={FAQ_USERS_QUESTION_1.firstLink}
        >
          {FAQ_USERS_QUESTION_1.firstLinkLabel}
        </Link>
        <span
          className={styles.complementaryContentColor}
          data-qa-tag="faq-nexplanon-question-1-complementary-content"
        >
          {FAQ_USERS_QUESTION_1.complementaryContent}
        </span>
      </p>
      {FAQ_USERS_1_LIST && (
        <ul className="tightened" data-qa-tag="faq-nexplanon-question-1-list">
          {FAQ_USERS_1_LIST.map((item, i) => (
            <li
              className="mt-2"
              key={`faq-users-${i}`}
              data-qa-tag={`faq-nexplanon-users-${i}-list`}
            >
              {item}
            </li>
          ))}
        </ul>
      )}
    </RichText>
  ),
};

export const FAQ_NEXPLANON_USERS = [
  FAQ_NEXPLANON_USERS_QUESTION_1,
  {
    title: '¿Qué medicamentos pueden interactuar con NEXPLANON?',
    content: (
      <RichText>
        <p data-qa-tag="faq-nexplanon-question-2-paragraph">
          Informe a su profesional de la salud sobre todos los medicamentos que
          toma, incluidos{' '}
          <Link
            data-design-category="content_link_vd"
            data-design-type="clickAction"
            data-design-action="Link"
            data-design-label="prescription and non-prescription medicines"
            data-design-nori_id="Accordion"
            data-design-module_name="using NEXPLANON"
            data-design-module_no="03"
            data-design-element_no="02"
            data-qa-tag="faq-nexplanon-question-2-link"
            href="/medicine-interactions/"
          >
            los medicamentos recetados y los medicamentos de venta libre
          </Link>
          , las vitaminas y los suplementos a base de hierbas. Algunos
          medicamentos pueden reducir la eficacia de NEXPLANON, entre ellos:
        </p>
        {FAQ_USERS_2_LIST && (
          <ul className="tightened" data-qa-tag="faq-nexplanon-question-2-list">
            {FAQ_USERS_2_LIST.map((item, i) => (
              <li
                className="mt-2"
                key={`faq-users-2-${i}`}
                data-qa-tag={`faq-nexplanon-users-${i}-list`}
              >
                {item}
              </li>
            ))}
          </ul>
        )}
        <p data-qa-tag="faq-nexplanon-question-2-paragraph-2">
          Consulte con su profesional de la salud si no está segura de que el
          medicamento que toma figure en la lista anterior.
        </p>
        <p data-qa-tag="faq-nexplanon-question-2-paragraph-3">
          Si está tomando medicamentos o productos a base de hierbas que pueden
          reducir la eficacia de NEXPLANON, usted y su médico pueden decidir
          mantener NEXPLANON en el lugar; en ese caso, usted deberá usar un
          anticonceptivo no hormonal adicional. Debido a que el efecto de otro
          medicamento sobre NEXPLANON puede durar hasta 28 días después de dejar
          de usar el medicamento, es necesario utilizar el anticonceptivo no
          hormonal adicional durante ese tiempo.
        </p>
        <p data-qa-tag="faq-nexplanon-question-2-paragraph-4">
          Cuando esté utilizando NEXPLANON, informe a todos sus profesionales de
          la salud que tiene NEXPLANON implantado en el brazo.
        </p>
      </RichText>
    ),
  },
  {
    title: '¿Quién no debe usar NEXPLANON?',
    content: (
      <RichText>
        <p data-qa-tag="faq-nexplanon-question-3-paragraph">
          <Link
            data-design-category="content_link_vd"
            data-design-type="clickAction"
            data-design-action="Link"
            data-design-label="Do not use NEXPLANON"
            data-design-nori_id="Accordion"
            data-design-module_name="NEXPLANON Users"
            data-design-module_no="03"
            data-design-element_no="03"
            data-qa-tag="faq-nexplanon-question-3-link"
            href="/side-effects/"
          >
            No use NEXPLANON
          </Link>{' '}
          si usted:
        </p>
        {FAQ_USERS_3_LIST_1 && (
          <ul className="tightened" data-qa-tag="faq-nexplanon-question-3-list">
            {FAQ_USERS_3_LIST_1.map((item, i) => (
              <li
                className="mt-2"
                key={`faq-users-3-1-${i}`}
                data-qa-tag={`faq-nexplanon-users-${i}-list`}
              >
                {item}
              </li>
            ))}
          </ul>
        )}
        <p data-qa-tag="faq-nexplanon-question-3-paragraph-2">
          Informe a su profesional de la salud si tiene o ha tenido alguna de
          las afecciones mencionadas en la lista anterior. Su profesional de la
          salud puede sugerirle un método anticonceptivo diferente.
        </p>
        <p data-qa-tag="faq-nexplanon-question-3-paragraph-3">
          Además, hable con su profesional de la salud acerca del uso de
          NEXPLANON si tiene:
        </p>
        {FAQ_USERS_3_LIST_2 && (
          <ul
            className="tightened"
            data-qa-tag="faq-nexplanon-question-3-list-2"
          >
            {FAQ_USERS_3_LIST_2.map((item, i) => (
              <li
                className="mt-2"
                key={`faq-users-3-1-${i}`}
                data-qa-tag={`faq-nexplanon-users-${i}-list-2`}
              >
                {item}
              </li>
            ))}
          </ul>
        )}
      </RichText>
    ),
  },
  {
    title: '¿Qué pasa si quedo embarazada mientras uso NEXPLANON?',
    content: (
      <RichText>
        <p data-qa-tag="faq-nexplanon-question-4-paragraph">
          Si cree que puede estar embarazada, debe visitar de inmediato a su
          profesional de la salud. Es importante extraer NEXPLANON y asegurarse
          de que el embarazo no sea ectópico (fuera del útero). Según la
          experiencia con otros anticonceptivos hormonales, no es probable que
          NEXPLANON provoque defectos de nacimiento.
        </p>
      </RichText>
    ),
  },
  {
    title: '¿Puedo usar NEXPLANON mientras estoy amamantando?',
    id: 'breastfeeding',
    content: (
      <RichText>
        <p data-qa-tag="faq-nexplanon-question-5-paragraph">
          Si está amamantando a su bebé, puede usar NEXPLANON si transcurrieron
          4 semanas desde el parto. Una pequeña cantidad de la hormona que
          contiene NEXPLANON pasa a su leche materna. Se ha estudiado la salud
          de un número reducido de niños lactantes hasta los 3 años cuyas madres
          utilizaban el implante. No se observó ningún efecto en el crecimiento
          y desarrollo de los niños. Si usted está amamantando y desea usar
          NEXPLANON, hable con un profesional de la salud para obtener más
          información.
        </p>
      </RichText>
    ),
  },
  {
    title: '¿NEXPLANON estará cubierto por el seguro?',
    content: (
      <RichText>
        <p data-qa-tag="faq-nexplanon-question-6-paragraph">
          Es posible que pueda obtener NEXPLANON gratis, en el marco de la Ley
          del Cuidado de Salud a Bajo Precio (Affordable Care Act, ACA).
          Consulte con su plan de seguro para obtener información sobre los{' '}
          <Link
            data-design-category="content_link_vd"
            data-design-type="clickAction"
            data-design-action="Link"
            data-design-label="cost"
            data-design-nori_id="Accordion"
            data-design-module_name="NEXPLANON Users"
            data-design-module_no="03"
            data-design-element_no="06"
            data-qa-tag="faq-nexplanon-question-6-link"
            href="/cost/"
          >
            costos
          </Link>{' '}
          y la{' '}
          <Link
            data-design-category="content_link_vd"
            data-design-type="clickAction"
            data-design-action="Link"
            data-design-label="insurance information"
            data-design-nori_id="Accordion"
            data-design-module_name="NEXPLANON Users"
            data-design-module_no="03"
            data-design-element_no="06"
            data-qa-tag="faq-nexplanon-question-6-link-2"
            href="/insurance-coverage/"
          >
            cobertura
          </Link>
          . Es posible que deba pagar un copago, un deducible u otros cargos.
        </p>
      </RichText>
    ),
  },
];
